export default "__VITE_ASSET__BMTm_HVv__"